<template>
  <!-- System pagination -->
  <nav
    class="pagination is-centered is-rounded"
    role="navigation"
    aria-label="pagination"
  >
    <ul class="pagination">
      <li class="page-item">
        <a
          data-toggle="tooltip"
          title="Primeira página"
          class="page-link"
          href="#"
          id="paginationFirst"
          aria-label="Primeira Página"
          @click.prevent="changePage(1)"
          :disabled="pagination.current_page <= 1"
        >
          <span aria-hidden="true"
            ><em class="fa fa-chevron-left icon-chevron"></em
            ><em class="fa fa-chevron-left icon-chevron"></em
          ></span>
        </a>
      </li>
      <li class="page-item">
        <a
          data-toggle="tooltip"
          title="Página anterior"
          class="page-link"
          id="paginationBack"
          href="#"
          aria-label="Anterior"
          @click.prevent="changePage(pagination.current_page - 1)"
          :disabled="pagination.current_page <= 1"
        >
          <span aria-hidden="true"
            ><em class="fa fa-chevron-left icon-chevron"></em
          ></span>
        </a>
      </li>
      <li class="page-item" v-for="page in pages" :key="page">
        <a
          id="paginationLink"
          class="page-link page-link-active"
          :class="isCurrentPage(page) ? 'is-current' : ''"
          @click.prevent="changePage(page)"
          >{{ page }}</a
        >
      </li>
      <li class="page-item">
        <a
          class="page-link"
          id="paginationNext"
          href="#"
          aria-label="Próximo"
          @click.prevent="changePage(pagination.current_page + 1)"
          :disabled="pagination.current_page >= pagination.last_page"
          data-toggle="tooltip"
          title="Próxima página"
        >
          <span aria-hidden="true"
            ><em class="fa fa-chevron-right icon-chevron"></em
          ></span>
        </a>
      </li>
      <li class="page-item">
        <a
          data-toggle="tooltip"
          title="Última página "
          class="page-link"
          href="#"
          id="Last"
          aria-label="Última Página"
          @click.prevent="changePage(pagination.last_page)"
          :disabled="pagination.current_page >= pagination.last_page"
        >
          <span aria-hidden="true"
            ><em class="fa fa-chevron-right icon-chevron"></em
            ><em class="fa fa-chevron-right icon-chevron"></em
          ></span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<style>
.pagination {
  margin-top: 40px;
  margin: auto;

  border: none;
}

.page-item .page-link {
  background-color: transparent;
  cursor: pointer;
  color: rgb(100, 95, 95);
  font-size: 13px;
  border: none;
}

.is-current {
  color: #fff !important;
}
</style>

<script>
export default {
  data() {
    return {};
  },
  props: ["pagination", "offset"],
  methods: {
    isCurrentPage(page) {
      return this.pagination.current_page === page;
    },
    changePage(page) {
      if (page > this.pagination.last_page) {
        page = this.pagination.last_page;
      }
      this.pagination.current_page = page;
      this.$emit("paginate");
    },
  },
  computed: {
    pages() {
      let pages = [];
      let from = this.pagination.current_page - Math.floor(this.offset / 2);
      if (from < 1) {
        from = 1;
      }
      let to = from + this.offset - 1;
      if (to > this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      while (from <= to) {
        pages.push(from);
        from++;
      }

      return pages;
    },
  },

  mounted() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/common/components/Pagination.vue